import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { environment } from '@siat-fe/env';

@Component({
  selector: 'siat-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  imports: [MatCardModule],
})
export class FooterComponent {
  /**
   * The application version.
   */
  appVersion = environment.version;
}
